import { client } from '@/services/api/axios.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TPlant } from '@/features/plants/schemas/plants.schema.ts';
import toast from 'react-hot-toast';

export const useDeleteSchedulePlantMutation = ({ plantId }: { plantId?: string }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ scheduleId }: { scheduleId?: string }) => {
      if (!plantId || !scheduleId) return;

      const { data } = await toast.promise(
        async () =>
          await client.delete<{ body: TPlant }>(`/plants/${plantId}/schedules/${scheduleId}`),
        {
          loading: 'Deleting schedule...',
          success: () => {
            return 'Successfully deleted the schedule.';
          },
          error: (_: unknown) => {
            return `Uh oh, there was an error with deleting the schedule.`;
          },
        }
      );

      return data?.body;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['plants', plantId, 'schedules'] });
    },
  });
};
